'use client';

import { useAuthStore } from '@/shared/stores/auth-store';
import { use } from 'react';
import { CreatorHomeTab } from '../creators/[handler]/_components/tabs/CreatorHomeTab';
import { useCreatorFromLayout } from '../creators/[handler]/_components/useCreatorFromLayout';

interface PageProps {
  params: Promise<{ handler: string }>;
}

export function ChannelHomePageClient({ params }: PageProps) {
  const { handler } = use(params);
  const { creator, isLoading } = useCreatorFromLayout(handler);
  const user = useAuthStore((s) => s.user);
  const isSubscribed = useAuthStore((s) => s.isSubscribed);
  const isGuest = !user || !isSubscribed;

  if (isLoading || !creator) return null;

  return <CreatorHomeTab creator={creator} handler={handler} isGuest={isGuest} />;
}
